// extracted by mini-css-extract-plugin
export default {"root":"ThreadsView_root__Wxq-U","spinner":"ThreadsView_spinner__CMMKC","hasActiveThread":"ThreadsView_hasActiveThread__ZJ2NV"};